"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/material/styles");
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Material-UI v5 用の withResponsive HOC
 * width: 'xs' | 'sm' | 'md' | 'lg' | 'xl' を props として渡す
 */
const withResponsive = Component => {
  return function ResponsiveWrapper(props) {
    const theme = (0, _styles.useTheme)();
    const isXs = (0, _useMediaQuery.default)(theme.breakpoints.only('xs'));
    const isSm = (0, _useMediaQuery.default)(theme.breakpoints.only('sm'));
    const isMd = (0, _useMediaQuery.default)(theme.breakpoints.only('md'));
    const isLg = (0, _useMediaQuery.default)(theme.breakpoints.only('lg'));
    const isXl = (0, _useMediaQuery.default)(theme.breakpoints.only('xl'));
    let width = null; // default fallback
    if (isXs) width = 'xs';else if (isSm) width = 'sm';else if (isMd) width = 'md';else if (isLg) width = 'lg';else if (isXl) width = 'xl';
    return /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
      width: width
    }));
  };
};
var _default = exports.default = withResponsive;